import * as React from 'react';
import { AuthContext } from "./AuthContext";
import type { IAuth } from "./AuthContext";

const useAuth = (): IAuth => {
  const ctx = React.useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside an <Auth> provider.');
  return ctx;
}

export { useAuth }
